export { default } from './SectionLegal';